module.exports = __webpack_public_path__ + "img/2.a8416932.png";